const ReportsModule = {
  namespaced: true,

  state: {
    xlsData: { items: [], headers: [], title: "", landscape: false },
    tableData: {
      items: [],
      title: "",
      footer: "",
      headers: [],
      index: true,
      landscape: false
    }
  },

  getters: {
    xlsData: state => state.tableData,
    tableData: state => state.tableData
  },

  mutations: {
    setXlsData(state, data) {
      state.xlsData = data;
    },

    setTableData(state, data) {
      state.tableData = data;
    }
  }
};

export default ReportsModule;
